import { render, staticRenderFns } from "./molecule.modal.ugcImageError.vue?vue&type=template&id=73aa0d60"
import script from "./molecule.modal.ugcImageError.vue?vue&type=script&lang=ts"
export * from "./molecule.modal.ugcImageError.vue?vue&type=script&lang=ts"
import style0 from "./molecule.modal.ugcImageError.vue?vue&type=style&index=0&id=73aa0d60&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports